import { Component, OnInit, ElementRef, QueryList, ViewChildren, ViewChild, HostBinding, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterLinkActive } from '@angular/router';
import { NavigationService } from '../navigation.service';
import { BreakpointsService } from '../breakpoints.service';
import { LayoutService } from '../layout.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { Subscription } from 'rxjs/Subscription';
import { concat, find } from 'lodash';
import * as FontFaceObserver from "fontfaceobserver";

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  animations: [
    trigger('menuState', [
      state('closed', style({
        opacity: '0',
        display: 'none'
      })),
      state('open',   style({
        opacity: '1',
        display: 'block'
      })),
      transition('closed => open', animate('250ms ease-in')),
      transition('open => closed', animate('250ms ease-out'))
    ])
  ],
  host: {
    '(window:resize)': 'onResize($event)',
    '[class]': 'getClass()'
  }
})
export class NavBarComponent implements OnInit {
  @ViewChild('navContainer') navContainer: ElementRef;
  currentSlug: any;
  previousSlug: any;
  childNavOffset: number;
  subcategory: string;
  leftMenu: any[];
  rightMenu: any[];
  isSticky: boolean;
  hideChildNav: boolean;
  breakpointSubscription: Subscription;
  navigationSubscription: Subscription;
  slugSubscription: Subscription;
  isMobileMenuAnimating: boolean = false;
  logoGif = {
    src: '/assets/images/logo_small.gif',
    retinaSrc: '/assets/images/logo_small.gif'
  };
  currentParentNavItemId: any;
  selectedParentNavItemId: any;

  constructor(
    private navigationService: NavigationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private BreakpointsService: BreakpointsService,
    private elRef: ElementRef,
    public LayoutService: LayoutService
  ) {
    
    const getMenus = (slugs = null) => {
      if (typeof this.navigationService.rightMenu !== 'undefined') {
        clearInterval(menuInterval);
        this.leftMenu = this.navigationService.leftMenu;
        this.rightMenu = this.navigationService.rightMenu;
        if (slugs) {
          this.onSlugChange(slugs);
        }
      }
    }

    getMenus();

    var menuInterval = setInterval(() => {
      getMenus();
    }, 100);

    // this.preloadGif(this.logoGif.src);
    // this.preloadGif(this.logoGif.retinaSrc);

    this.navigationSubscription = router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((val) => {
        this.isSticky = this.navigationService.isSticky;
    });

    this.slugSubscription = this.navigationService.slugsObs.pairwise().subscribe((slugs) => {
      clearInterval(menuInterval);

      if (typeof this.navigationService.rightMenu === 'undefined') {
        menuInterval = setInterval(() => {
          getMenus(slugs);
        }, 100);
      } else {
        this.onSlugChange(slugs);
      }
    });

    let image = new Image;
    image.src = '/assets/images/logo_small.gif';
  }

  onSlugChange(slugs) {
    this.previousSlug = slugs[0];
    this.currentSlug = slugs[1];

    if (this.currentSlug.parent !== this.previousSlug.parent && this.BreakpointsService.device === 'desktop') {
      this.hideChildNav = true;
    }

    let allNavItems = concat(this.leftMenu, this.rightMenu);
    let parentNavItem = find(allNavItems, {slug: this.currentSlug.parent});
    let childNavItem;
    if (parentNavItem && typeof parentNavItem.children !== 'undefined' && parentNavItem.children.length > 0) {
      childNavItem = find(parentNavItem.children, {slug: slugs[1].child});
    }
    this.currentParentNavItemId = parentNavItem ? parentNavItem.id : null;
    this.selectedParentNavItemId = this.currentParentNavItemId;
    

    if (this.currentSlug.parent !== this.previousSlug.parent && this.BreakpointsService.device === 'desktop') {
      this.updateView();
      
      setTimeout(() => {
        this.hideChildNav = false;
      });
    }
  }

  getUrl(item) {
    return ['/' + item.slug];
  }

  getQueryParamsHandling(item) {
    if (typeof item.children !== 'undefined'
      && item.children.length > 0
      && this.BreakpointsService.device !== 'desktop'
      && this.selectedParentNavItemId !== item.id) {
      return 'preserve';
    } else {
      return null;
    }
  }

  onParentNavLinkClick(item) {
    if (this.BreakpointsService.device !== 'desktop') {
      this.selectedParentNavItemId = item.id;
    }

    if ((typeof item.children === 'undefined'
      || item.children.length === 0)
      && this.BreakpointsService.device !== 'desktop') {
      this.closeMenu();
    }
  }

  onChildNavLinkClick(item, childItem) {
    this.closeMenu();
  }

  ngOnDestroy() {
    if (typeof this.breakpointSubscription !== 'undefined') {
      this.breakpointSubscription.unsubscribe();
    }
    if (typeof this.navigationSubscription !== 'undefined') {
      this.navigationSubscription.unsubscribe();
    }
    if (typeof this.slugSubscription !== 'undefined') {
      this.slugSubscription.unsubscribe();
    }
  }

  isActive(item) {
    if (this.BreakpointsService.device === 'desktop') {
      return this.currentParentNavItemId === item.id
    } else {
      return this.selectedParentNavItemId === item.id
    }
  }

  preloadGif(src) {
    let image = new Image();
    image.src = src;
  }

  menuState() {
    return this.navigationService.isMobileMenuOpen ? 'open' : 'closed';
  }

  animationStarted($event) {
    this.isMobileMenuAnimating = true;
  }

  animationDone($event) {
    this.isMobileMenuAnimating = false;
  }

  getClass() {
    let _class = this.isSticky ? 'is-sticky' : '';
    _class += this.LayoutService.showSplashscreen || this.LayoutService.showSplashscreen === null ? '' : ' is-visible';
    _class += this.navigationService.isMobileMenuOpen || this.isMobileMenuAnimating ? ' is-open' : ' is-closed';
    _class += this.navigationService.isTransparent ? ' is-transparent' : '';
    return _class;
  }

  onResize($event) {
    setTimeout(() => {
      this.getNavbarHeight();
    }); 
  }

  openMenu() {
    this.navigationService.isMobileMenuOpen = true;
  }

  closeMenu() {
    this.navigationService.isMobileMenuOpen = false;
    this.selectedParentNavItemId = this.currentParentNavItemId;
  }

  getNavbarHeight() {
    let height = this.elRef.nativeElement.clientHeight;
    if (height > 0) {
      this.navigationService.navbarHeight = height;
    }
  }

  updateView() {
    setTimeout(() => {
      this.updateViewFunc();
    }); 
  }

  updateViewFunc() {
    if (this.BreakpointsService.device === 'desktop') {

      this.selectedParentNavItemId = this.currentParentNavItemId;

      let navItems = this.navContainer.nativeElement.getElementsByClassName('navItem');
      let activeItem = find(navItems, (item: any) => {
        return item.classList.contains('active')
      });

      this.navigationService.activeNavItemOffset = typeof activeItem !== 'undefined' ? activeItem.offsetLeft : 0;
      this.navigationService.secondNavItemOffset = navItems.length > 1 ? navItems[1].offsetLeft : 0;
    }

    this.getNavbarHeight();
  }

  ngOnInit() {
    setTimeout(() => {
      this.updateView();

      this.breakpointSubscription = this.BreakpointsService.deviceObs.subscribe((device) => {
        this.updateView();
      });
    });

    var font = new FontFaceObserver('AGBuchExtendedBQ', {
      weight: 500
    });

    font.load().then(() => {
      this.updateViewFunc();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/nav-bar/nav-bar.component.ts